import { render, staticRenderFns } from "./introduce-item.vue?vue&type=template&id=0ea57d31"
import script from "./introduce-item.vue?vue&type=script&lang=ts"
export * from "./introduce-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports